/* Design tokens — BOTNATURA (from logo.png) */

const primary = '#286840'
const primarySoft = '#E8F3EC'
const brandDark = '#143528'
const text = '#3D4A42'
const muted = '#686868'
const bgApp = '#F2F6F3'
const surface = '#FFFFFF'
const surfaceAlt = '#EDF4EF'
const borderSoft = '#D5E3DA'
const success = '#8FBF3A'
const warning = '#E6B422'
const danger = '#E04545'
const info = '#3D8B6E'
const accent = '#A8C840'

const bgPrimaryLight = 'rgba(40, 104, 64, 0.35)'
const primaryGradient = `linear-gradient(135deg, ${primary} 0%, #1B4D30 100%)`
const brandDarkGradient = `linear-gradient(135deg, ${brandDark} 0%, #0A1F16 100%)`

const boxShadow = '0 1px 3px rgba(20, 53, 40, 0.06), 0 4px 12px rgba(20, 53, 40, 0.04)'
const shadowSoft = '0 2px 8px rgba(20, 53, 40, 0.08)'
const shadowActive = '0 4px 14px rgba(40, 104, 64, 0.28)'

const radiusSm = '8px'
const radiusMd = '16px'
const radiusLg = '24px'
const radiusPill = '999px'

const widthFull = '260px'
const widthResize = '64px'
const widthWithPadding = '240px'
const widthResizeWithPadding = '44px'
const heightHeader = '60px'
const heightFooter = '28px'
const heightControl = '38px'
const heightControlSm = '32px'

const fontFamily = '"Montserrat", sans-serif'

export {
  primary,
  primarySoft,
  brandDark,
  text,
  muted,
  bgApp,
  surface,
  surfaceAlt,
  borderSoft,
  success,
  warning,
  danger,
  info,
  accent,
  bgPrimaryLight,
  primaryGradient,
  brandDarkGradient,
  boxShadow,
  shadowSoft,
  shadowActive,
  radiusSm,
  radiusMd,
  radiusLg,
  radiusPill,
  widthFull,
  widthResize,
  widthWithPadding,
  widthResizeWithPadding,
  heightHeader,
  heightFooter,
  heightControl,
  heightControlSm,
  fontFamily,
}
